import styled from 'styled-components';

import { media, space } from '../../ui/helpers';
import asterisk from '../../images/asterisk.png';
import { colors } from '../../ui/design-tokens';

const Module = styled.div`
  width: 100%;
`;

const Container = styled.div<{ component: boolean; center: boolean }>`
  color: ${({ theme }) => theme.text};

  ${({ component }) => (component ? `padding: ${space(6)} ${space(3)};` : '')}
  ${({ center }) => (center ? 'text-align: center' : '')}

  ${media.min('reader')`
    padding: ${space(6)} 0;
  `}

  h2,
  .title2 {
    margin: ${space(8)} 0 ${space(6)};
  }

  .title-2 {
    margin-bottom: ${space(2)};
  }

  h3,
  .title3 {
    margin: ${space(6)} 0 ${space(4)};
  }

  h2 + h3,
  h2 + .title3,
  .title2 + h3,
  .title2 + .title3 {
    margin-top: 0;
  }

  img {
    margin: ${space(6)} 0;

    ${media.min('medium')`
      max-width: none;
      width: 100%;
    `};
  }

  a {
    color: ${({ theme }) => theme?.clickable || colors.primary[700]} !important;

    &:hover {
      color: ${({ theme }) => theme?.hover || colors.primary[500]} !important;
    }
  }

  .button {
    color: ${({ theme }) => theme?.secondary || colors.primary[900]} !important;

    &:hover,
    &:active {
      color: ${({ theme }) =>
        theme?.secondaryHover || theme?.hover || colors.primary[800]} !important;
    }
  }

  .button,
  .link {
    display: table;
  }

  p + .p-big {
    margin-top: ${space(6)};
  }

  p + ul,
  p + ol,
  p + .button {
    margin-top: ${space(4)};
  }

  p + p,
  p + .link {
    margin-top: ${space(3)};
  }

  ul + *,
  ol + * {
    margin-top: ${space(6)};
  }

  ul + .link,
  ol + .link {
    margin-top: ${space(3)};
  }

  ul,
  ol {
    margin-left: ${space(3)};
    padding-left: ${space(3)};

    ${media.min('medium')`
      margin-left: ${space(6)};
    `};

    ul,
    ol {
      margin-top: ${space(2)};
    }
  }

  li:not(:last-child) {
    margin: 0 0 ${space(2)};
  }

  ul li {
    position: relative;

    &:before {
      background: url(${asterisk}) 50% no-repeat;
      background-size: contain;
      content: '';
      height: 14px;
      left: ${space(-3)};
      position: absolute;
      top: 0.45rem;
      width: 14px;
    }
  }

  ol li {
    list-style: decimal;
  }

  .p-big + p,
  .p-big + ul,
  .p-big + ol,
  .p-big + .p-big {
    margin-top: ${space(4)};
  }

  .p-big + .button {
    margin-top: ${space(6)};
  }

  .p-big + .link {
    margin-top: ${space(3)};
  }

  .button + ul,
  .button + ol,
  .button + p,
  .button + .p-big {
    margin-top: ${space(8)};
  }

  .button + .button {
    margin-top: ${space(3)};
  }

  .button + .link {
    margin-top: ${space(4)};
  }

  .link + * {
    margin-top: ${space(8)};
  }

  .link + .link {
    margin-top: ${space(4)};
  }

  * {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .text-align-center {
    text-align: center;
  }
`;

export { Module, Container };
